import { useModal } from '@/customHooks/useModal'
import { TMapBasicData } from '@/tmapBasicInfo/TMapBasicData'
import { TMapBasicLogic } from '@/tmapBasicInfo/TMapBasicLogic'
import React, { useRef } from 'react'
import Modal from 'react-modal'
import LocationCodeDetailModal from '@/views/modal/LocationCodeDetailModal'
import { TimeTableModal } from './TimeTableModal'

type Props = {
  isOpen: boolean
  closeModal: () => void
  mapRank: number
  mapSeed: number
  places: number[]
}

const TMapDetailModal = ({ isOpen, closeModal, mapRank, mapSeed, places }: Props) => {
  // #region フック

  const locationCodeDetailModal = useModal()

  const locationCode = useRef(0)

  const timeTableModal = useModal()

  const floor = useRef<number>(-1)

  const boxIndex = useRef<number>(-1)

  // #endregion フック

  // #region スタイル

  const modalStyle: Modal.Styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(240,240,240,0.7)'
    },
    content: {
      position: 'absolute',
      backgroundColor: '#f0f0f0',
      border: 'solid 1px #000000',
      top: '5%',
      left: '35%',
      right: '35%',
      bottom: '5%',
      padding: '0px'
    }
  }

  const headerStyle: React.CSSProperties = {
    margin: '5px 0px 0px 10px'
  }

  const mainStyle: React.CSSProperties = {
    margin: '10px 10px 10px 10px'
  }

  const buttonsStyle: React.CSSProperties = {
    marginTop: '10px',
    textAlign: 'right'
  }

  const anchorStyle: React.CSSProperties = {
    color: 'blue'
  }

  const floorMapAreaStyle: React.CSSProperties = {
    marginLeft: '20px',
    backgroundColor: '#FFFFFF',
    width: '300px',
    height: '440px',
    border: 'solid 1px',
    overflowY: 'scroll'
  }

  const floorMapStyle = {
    fontFamily: 'ＭＳ ゴシック'
  }

  // #endregion スタイル

  // #region イベント

  const onClickLocationCode = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    const code = e.currentTarget.getAttribute('data-map-code')
    locationCode.current = parseInt(code || '0', 10)
    locationCodeDetailModal.openModal()
  }
  const onTBoxClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    const tBoxId = e.currentTarget.getAttribute('data-tbox-id')
    floor.current = parseInt(tBoxId?.split('_')[0] || '-1')
    boxIndex.current = parseInt(tBoxId?.split('_')[1] || '-1')
    timeTableModal.openModal()
  }

  // #endregion イベント

  if (mapRank < 2 || mapSeed < 0) {
    return (
      <Modal isOpen={isOpen} style={modalStyle} ariaHideApp={false}>
        <h1>取得失敗</h1>
      </Modal>
    )
  }

  const basicData: TMapBasicData = TMapBasicLogic.calculateBasicData(mapRank, mapSeed)

  const printFloorMap = (basicData: TMapBasicData): JSX.Element[] => {
    const list: JSX.Element[] = []
    const tBoxRankLabel = ['Ｉ', 'Ｈ', 'Ｇ', 'Ｆ', 'Ｅ', 'Ｄ', 'Ｃ', 'Ｂ', 'Ａ', 'Ｓ']
    for (let i = 0; i < basicData.floorMapDataList.length; i++) {
      list.push(
        <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-label`}>
          地下{basicData.floorMapDataList[i].floor.toString(10).padStart(2, '0')}階<br />
        </React.Fragment>
      )
      for (let j = 0; j < basicData.floorMapDataList[i].height; j++) {
        for (let k = 0; k < basicData.floorMapDataList[i].width; k++) {
          if (
            basicData.floorMapDataList[i].getFloorMapValue(k, j) == 1 ||
            basicData.floorMapDataList[i].getFloorMapValue(k, j) == 3
          ) {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                ■
              </React.Fragment>
            )
          } else if (
            basicData.floorMapDataList[i].getFloorMapValue(k, j) == 4 &&
            JSON.stringify(basicData.floorMapDataList[i].upStairsCoordinate) ===
              JSON.stringify({ x: k, y: j })
          ) {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                △
              </React.Fragment>
            )
          } else if (basicData.floorMapDataList[i].getFloorMapValue(k, j) == 5) {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                ▽
              </React.Fragment>
            )
          } else if (basicData.floorMapDataList[i].getFloorMapValue(k, j) >= 10) {
            list.push(
              <a
                href='#'
                style={anchorStyle}
                key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}
                data-tbox-id={`${basicData.floorMapDataList[i].floor}_${
                  ((basicData.floorMapDataList[i].getFloorMapValue(k, j) / 10) | 0) - 1
                }`}
                onClick={onTBoxClick}
              >
                {tBoxRankLabel[basicData.floorMapDataList[i].getFloorMapValue(k, j) % 10]}
              </a>
            )
          } else {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                {'　'}
              </React.Fragment>
            )
          }
        }
        list.push(
          <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}`}>
            <br />
          </React.Fragment>
        )
      }
      list.push(
        <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-br`}>
          <br />
        </React.Fragment>
      )
    }
    return list
  }

  return (
    <Modal isOpen={isOpen} style={modalStyle} ariaHideApp={false}>
      <h1 style={headerStyle}>
        宝の地図詳細
        {`（0x${mapRank.toString(16).padStart(2, '0').toUpperCase()} 0x${mapSeed
          .toString(16)
          .padStart(4, '0')
          .toUpperCase()}）`}
      </h1>
      <main style={mainStyle}>
        地図Rank：0x{basicData.mapRank.toString(16).padStart(2, '0').toUpperCase()}
        <br />
        地図Seed：0x{basicData.mapSeed.toString(16).padStart(4, '0').toUpperCase()}
        <br />
        地図名：
        {basicData.mapName1.name}
        {basicData.mapName2.name}
        {basicData.mapName3.name}
        Lv{basicData.mapLevel}
        <br />
        場所候補：
        {places.map((s: number) => (
          <React.Fragment key={s}>
            <a href='#' style={anchorStyle} data-map-code={s} onClick={onClickLocationCode}>
              {'0x' + s.toString(16).toLocaleUpperCase().padStart(2, '0')}
            </a>
            &nbsp;
          </React.Fragment>
        ))}
        <br />
        地形：{basicData.mapType.name}
        <br />
        深さ：{basicData.mapFloorCount}
        <br />
        B1F敵ランク：{basicData.b1fEnemyRank}
        <br />
        ボス：{basicData.boss.name}
        <br />
        宝箱の数：
        <br />
        &emsp; S：{basicData.treasureBoxCountList[9]}&ensp; A：{basicData.treasureBoxCountList[8]}&ensp; B：
        {basicData.treasureBoxCountList[7]}&ensp; C：{basicData.treasureBoxCountList[6]}&ensp; D：
        {basicData.treasureBoxCountList[5]}&ensp; E：{basicData.treasureBoxCountList[4]}&ensp; F：
        {basicData.treasureBoxCountList[3]}&ensp; G：{basicData.treasureBoxCountList[2]}&ensp; H：
        {basicData.treasureBoxCountList[1]}&ensp; I：{basicData.treasureBoxCountList[0]}
        <br />
        フロアマップ（宝箱クリックでタイムテーブル表示）：
        <div style={floorMapAreaStyle}>
          <pre style={floorMapStyle}>{printFloorMap(basicData)}</pre>
        </div>
        <div style={buttonsStyle}>
          <button onClick={closeModal}>閉じる</button>
        </div>
      </main>
      <LocationCodeDetailModal
        isOpen={locationCodeDetailModal.isOpen}
        closeModal={locationCodeDetailModal.closeModal}
        mapCode={locationCode.current}
      />
      <TimeTableModal
        isOpen={timeTableModal.isOpen}
        basicData={basicData}
        floor={floor.current}
        boxIndex={boxIndex.current}
        closeModal={timeTableModal.closeModal}
      />
    </Modal>
  )
}

export default TMapDetailModal
